import { z } from 'zod'

export const billingAutoTopupEvidenceWriteResponseSchema = z.object({}).passthrough()
export type BillingAutoTopupEvidenceWriteResponse = z.infer<typeof billingAutoTopupEvidenceWriteResponseSchema>
